import { render } from "./ChosenFieldset.vue?vue&type=template&id=311f8399"
import script from "./ChosenFieldset.vue?vue&type=script&lang=js"
export * from "./ChosenFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__